export const getContentTypeRelatedAspectClass = (contentType: string) => {
  const category = contentType.charAt(0).toUpperCase() + contentType.slice(1);
  const cardHeaderAspectClass =
    contentType === 'video' || contentType === 'collection'
      ? 'aspect-video'
      : 'aspect-square';
  const imageAspectClass =
    contentType === 'video' || contentType === 'collection'
      ? 'video'
      : 'square';
  return { category, cardHeaderAspectClass, imageAspectClass };
};

const isValidMarginPaddingClass = (className: string) => {
  const validMarginsPaddings = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
  ];
  return validMarginsPaddings.some(prefix =>
    className.startsWith(`${prefix}-`),
  );
};

export const getValidClassNames = (classNames?: string) => {
  return classNames?.split(' ').filter(isValidMarginPaddingClass).join(' ');
};
